import clsx from 'clsx'
import {
  IconRedBed,
  IconRedBriefcase,
  IconRedCalendar,
  IconRedCoins,
  IconRedDollar,
  IconRedInfo,
  IconRedPiggyBank,
  IconRedPlane,
  IconRedShield,
  IconRedTicket,
} from './Icons'

const icons = {
  coins: IconRedCoins,
  info: IconRedInfo,
  bank: IconRedPiggyBank,
  bed: IconRedBed,
  calendar: IconRedCalendar,
  dollar: IconRedDollar,
  ticket: IconRedTicket,
  shield: IconRedShield,
  plane: IconRedPlane,
  briefcase: IconRedBriefcase,
} as const

interface RedIconProps {
  iconsvg: keyof typeof icons | undefined
  small?: boolean
  className?: string
}

export default function RedIcon({
  iconsvg,
  small = false,
  className = '',
}: RedIconProps) {
  const IconComponent = iconsvg ? icons[iconsvg] : null

  return IconComponent ? (
    <div
      className={clsx(
        'bg-primary-100 rounded-full m-0 flex items-center justify-center',
        small
          ? 'h-8 w-8 [&>svg]:w-4 [&>svg]:h-4'
          : 'md:h-16 md:w-16 h-8 w-8 md:[&>svg]:w-8 md:[&>svg]:h-8 [&>svg]:w-4 [&>svg]:h-4',
        className,
      )}
    >
      <IconComponent />
    </div>
  ) : null
}
